module.exports = __webpack_public_path__ + "static/media/jeff-l.d4af38ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/jeff-l.jpg
// module id = 489
// module chunks = 0